/**
 * 業務マップ（F1）の Query キー。
 *
 * @graph-stack spec-console
 * @graph-domain Engineering
 * @graph-business 業務マップの読取 procedure の Query キーを定義する。
 * @graph-connects none
 */
import type { LocaleKeyPart } from './common.js';

/** 業務マップの仕様グラフ読取のキー。 @graph-connects none */
export const businessMapQueryKeys = {
  /*
   * 一覧のキーも案件番号を載せる。載せないと、案件を選んだ一覧と現在版の一覧が同じキーの
   * 下で相手を上書きし、案件を外した瞬間に案件の姿がそのまま残る（あるいはその逆）。
   * 並びは detail のキーに揃えて `[..., pjNumber ?? null, locale ?? null]` にする。
   * 案件番号は number である（作り直しの契約）。
   */
  getBusinessMap: (locale: LocaleKeyPart, pjNumber?: number) =>
    ['specGraph', 'getBusinessMap', pjNumber ?? null, locale ?? null] as const,
} as const;
